// extracted by mini-css-extract-plugin
export var box = "section-text-boxes-module--box--91c5e";
export var boxHeading = "section-text-boxes-module--boxHeading--22a21";
export var boxes = "section-text-boxes-module--boxes--f31e4";
export var heading = "section-text-boxes-module--heading--5aa9a";
export var sectionTextBoxes = "section-text-boxes-module--sectionTextBoxes--a48d9";